import { OfferOrderUrlConstant } from 'src/constants';
import {
  OfferOrderDto,
  OfferOrderDetailsDto,
  GetAllOfferOrderListDto,
  GetAllOfferOrderListResponseDto,
  GetAnyOfferOrderDetailsDto,
  UpdateAnyOfferOrderDto,
  DeleteOfferOrderDto,
  OfferOrderCardPaymentDetailsDto,
  CreateOfferOrderCardPaymentRefundDto,
  GetOfferOrderCardPaymentListDto,
  GetOfferOrderCardPaymentListResponseDto,
  GetOfferOrderCardPaymentDetailsDto,
  UpdateOfferOrderListStatusDto,
  CreateOfferOrderFileExportDto,
  DownloadOfferOrderSubscriptionAgreementDto,
  DownloadOfferOrderSubscriptionAgreementResponseDto,
  ResendOfferOrderEmailDto,
} from 'src/dtos';
import { FileExportDto } from 'src/dtos/fileExport.dto';
import { ConfigService } from 'src/services/ConfigService';
import { httpRequest, replacePlaceholders } from 'src/utils';

export class OfferOrdersApi {
  private _configService: ConfigService;

  constructor(configService: ConfigService) {
    this._configService = configService;
  }

  async listAny({ queryParams }: GetAllOfferOrderListDto): Promise<GetAllOfferOrderListResponseDto> {
    return httpRequest<GetAllOfferOrderListResponseDto>({
      method: 'GET',
      url: OfferOrderUrlConstant.LIST,
      authToken: this._configService.authToken,
      queryParams,
    });
  }

  async retrieveAny({ params }: GetAnyOfferOrderDetailsDto): Promise<OfferOrderDetailsDto> {
    const url = replacePlaceholders(OfferOrderUrlConstant.RETRIEVE, params);

    return httpRequest<OfferOrderDetailsDto>({
      method: 'GET',
      url,
      authToken: this._configService.authToken,
    });
  }

  async updateListStatus({ body }: UpdateOfferOrderListStatusDto): Promise<OfferOrderDto> {
    return httpRequest<OfferOrderDetailsDto>({
      method: 'PUT',
      url: OfferOrderUrlConstant.UPDATE_LIST_STATUS,
      body,
      authToken: this._configService.authToken,
    });
  }

  async updateAny({ params, body }: UpdateAnyOfferOrderDto): Promise<OfferOrderDetailsDto> {
    const url = replacePlaceholders(OfferOrderUrlConstant.UPDATE, params);

    return httpRequest<OfferOrderDetailsDto>({
      method: 'PUT',
      url,
      body,
      authToken: this._configService.authToken,
    });
  }

  async delete({ params }: DeleteOfferOrderDto): Promise<void> {
    const url = replacePlaceholders(OfferOrderUrlConstant.DELETE, params);

    return httpRequest<void>({
      method: 'DELETE',
      url,
      authToken: this._configService.authToken,
    });
  }

  async createRefund({ body, params }: CreateOfferOrderCardPaymentRefundDto): Promise<OfferOrderDetailsDto> {
    const url = replacePlaceholders(OfferOrderUrlConstant.CREATE_CARD_PAYMENT_REFUND, params);

    return httpRequest<OfferOrderDetailsDto>({
      method: 'POST',
      url,
      body,
      authToken: this._configService.authToken,
    });
  }

  async listCardPayments({
    queryParams,
  }: GetOfferOrderCardPaymentListDto): Promise<GetOfferOrderCardPaymentListResponseDto> {
    return httpRequest<GetOfferOrderCardPaymentListResponseDto>({
      method: 'GET',
      url: OfferOrderUrlConstant.LIST_CARD_PAYMENTS,
      queryParams,
      authToken: this._configService.authToken,
    });
  }

  async retrieveCardPayment({ params }: GetOfferOrderCardPaymentDetailsDto): Promise<OfferOrderCardPaymentDetailsDto> {
    const url = replacePlaceholders(OfferOrderUrlConstant.RETRIEVE_CARD_PAYMENT, params);

    return httpRequest<OfferOrderCardPaymentDetailsDto>({
      method: 'GET',
      url,
      authToken: this._configService.authToken,
    });
  }

  async createFileExport({ body }: CreateOfferOrderFileExportDto): Promise<FileExportDto> {
    return httpRequest<FileExportDto>({
      method: 'POST',
      url: OfferOrderUrlConstant.CREATE_FILE_EXPORT,
      body,
      authToken: this._configService.authToken,
    });
  }

  async downloadSubscriptionAgreement({ params }: DownloadOfferOrderSubscriptionAgreementDto): Promise<Blob> {
    const url = replacePlaceholders(OfferOrderUrlConstant.DOWNLOAD_SUBSCRIPTION_AGREEMENT, params);

    const downloadSubAgreement = await httpRequest<DownloadOfferOrderSubscriptionAgreementResponseDto>({
      method: 'GET',
      url,
      authToken: this._configService.authToken,
    });

    return httpRequest<Blob>({
      method: 'GET',
      url: downloadSubAgreement.downloadUrl,
      responseType: 'blob',
    });
  }

  async resendEmail({ params, body }: ResendOfferOrderEmailDto): Promise<void> {
    const url = replacePlaceholders(OfferOrderUrlConstant.RESEND_EMAIL, params);

    return httpRequest<void>({
      method: 'PUT',
      url,
      body,
      authToken: this._configService.authToken,
    });
  }
}
